import {
	IconCheckOutline18 as CheckIcon,
	IconChevronDownOutline18 as ChevronDownIcon,
} from "nucleo-ui-outline-18"

import { Button } from "@productlane/ui"
import {
	DropdownMenu,
	DropdownMenuGroup,
	DropdownMenuItem,
} from "@productlane/ui/src/components/internal/dropdown"

import type { MemberFilter } from "./member-filters"
import { MEMBER_FILTER_LABELS, MEMBER_FILTER_ORDER } from "./member-filters"

export function MemberRoleFilter({
	value,
	onChange,
	includePending,
}: {
	value: MemberFilter
	onChange: (value: MemberFilter) => void
	includePending: boolean
}) {
	const options = includePending
		? MEMBER_FILTER_ORDER
		: MEMBER_FILTER_ORDER.filter((o) => o !== "pending")

	return (
		<DropdownMenu
			trigger={
				<Button variant="outline" iconRight={ChevronDownIcon}>
					{MEMBER_FILTER_LABELS[value]}
				</Button>
			}
			contentProps={{ side: "bottom", align: "end" }}
		>
			<DropdownMenuGroup>
				{options.map((option) => (
					<DropdownMenuItem
						key={option}
						onClick={() => onChange(option)}
						shortcut={
							value === option ? <CheckIcon className="h-4 w-4" /> : undefined
						}
					>
						{MEMBER_FILTER_LABELS[option]}
					</DropdownMenuItem>
				))}
			</DropdownMenuGroup>
		</DropdownMenu>
	)
}
